import React from "react";

import "../fonts/Vito/Vito.css";
import { css, Global, useTheme } from "@emotion/react";

const GlobalStyle = () => {
    const theme = useTheme();

    return (
        <Global
            styles={css`
                /* Below this line: Bulma's former "base" reset (minireset +
                generic element styles), ported here so it keeps applying
                after Bulma itself was removed. Placed first so the
                site-specific overrides further down keep winning exactly
                as they did before, when Bulma's CSS loaded earlier in the
                cascade than this file. */
                html,
                body,
                p,
                ol,
                ul,
                li,
                dl,
                dt,
                dd,
                blockquote,
                figure,
                fieldset,
                legend,
                textarea,
                pre,
                iframe,
                hr,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    margin: 0;
                    padding: 0;
                }

                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    font-size: 100%;
                    font-weight: normal;
                }

                ul {
                    list-style: none;
                }

                button,
                input,
                select,
                textarea {
                    margin: 0;
                }

                img,
                video {
                    height: auto;
                    max-width: 100%;
                }

                iframe {
                    border: 0;
                }

                table {
                    border-collapse: collapse;
                    border-spacing: 0;
                }

                td,
                th {
                    padding: 0;

                    &:not([align]) {
                        text-align: inherit;
                    }
                }

                html {
                    background-color: white;
                    font-size: 16px;
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                    min-width: 300px;
                    overflow-x: hidden;
                    overflow-y: scroll;
                    text-rendering: optimizeLegibility;
                    text-size-adjust: 100%;
                }

                article,
                aside,
                figure,
                footer,
                header,
                hgroup,
                section {
                    display: block;
                }

                body {
                    color: hsl(0, 0%, 29%);
                    font-size: 1em;
                    font-weight: 400;
                    line-height: 1.5;
                }

                a {
                    color: #05235f;
                    cursor: pointer;
                    text-decoration: none;

                    strong {
                        color: currentColor;
                    }

                    &:hover {
                        color: hsl(0, 0%, 21%);
                    }
                }

                code {
                    background-color: hsl(0, 0%, 96%);
                    color: rgb(153.5, 0, 26.6956521739);
                    font-size: 0.875em;
                    font-weight: normal;
                    padding: 0.25em 0.5em 0.25em;
                }

                hr {
                    background-color: hsl(0, 0%, 96%);
                    border: none;
                    display: block;
                    height: 2px;
                    margin: 1.5rem 0;
                }

                input[type="checkbox"],
                input[type="radio"] {
                    vertical-align: baseline;
                }

                small {
                    font-size: 0.875em;
                }

                span {
                    font-style: inherit;
                    font-weight: inherit;
                }

                pre {
                    -webkit-overflow-scrolling: touch;
                    background-color: hsl(0, 0%, 96%);
                    color: hsl(0, 0%, 29%);
                    font-size: 0.875em;
                    overflow-x: auto;
                    padding: 1.25rem 1.5rem;
                    white-space: pre;
                    word-wrap: normal;

                    code {
                        background-color: transparent;
                        color: currentColor;
                        font-size: 1em;
                        padding: 0;
                    }
                }

                :root {
                    --font-family-vito: "Vito", verdana, arial, helvetica,
                        roboto, sans-serif;
                    --focus-ring-color: ${theme.colors.blue
                        .lighten(2)
                        .toString()};
                    --focus-ring-outline: 2px solid var(--focus-ring-color);
                }

                body {
                    font-family: var(--font-family-vito);
                    font-size: 1.1em;
                    background-color: white;
                }

                * {
                    box-sizing: border-box;
                }

                *,
                button,
                input,
                select,
                textarea {
                    font-family: inherit;
                }

                .has-text-right {
                    text-align: right;
                }

                .has-text-center {
                    text-align: center;
                }

                .is-flex {
                    display: flex;
                }

                textarea::placeholder,
                input::placeholder {
                    color: ${theme.colors.blue.toString()} !important;
                    opacity: 0.55 !important;
                }

                .box {
                    color: unset;
                }

                .button {
                    font-weight: 500;
                    text-transform: uppercase;
                }

                .darkButton {
                    background-color: hsl(0, 0%, 71%);
                    color: hsl(0, 0%, 100%);
                }

                .is-light {
                    color: white;
                }

                strong {
                    font-weight: 500;
                    color: inherit;
                }

                .select {
                    &::after {
                        top: 17px !important;
                        right: 10px !important;
                        border-color: ${theme.colors.grey.toString()} !important;
                    }
                }

                .is-full-width {
                    width: 100%;
                }

                ul {
                    margin-top: 1em;
                    margin-bottom: 1em;
                    margin-left: 2em;
                    list-style-type: disc;
                }

                p:not(:last-child) {
                    margin-bottom: 1em;
                }

                .product-details {
                    flex: 1 1 0;

                    .columns {
                        align-items: flex-end;
                    }

                    .column {
                        padding-top: 2px;
                        padding-bottom: 2px;

                        &.details-value {
                            font-weight: 500;
                        }
                    }

                    .total-amount {
                        display: block;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        font-size: 24px;
                        font-weight: 500;

                        .column {
                            display: inline-block;
                        }

                        .column:last-child {
                            float: right;
                        }
                    }

                    ul {
                        padding-left: 1.1em;
                        list-style-type: disc;
                    }

                    @media (min-width: 1024px) {
                        padding-top: 40px;
                        padding-bottom: 40px;
                        margin-top: -20px;
                        border-top-left-radius: 0;
                        border-top-right-radius: 0;
                    }
                }
            `}
        />
    );
};
export default GlobalStyle;
